// import React, { useEffect, useState } from "react";
// import OrderCard from "../components/myAccountComponents/OrderCard";
// import Breadcrumb from "../components/BreadCrumb";
// import SelectDropdown from "../customStyles/SelectDropdown";
// import { Search } from "lucide-react";
// import { IoCaretDown } from "react-icons/io5";
// import api from "../common/apiClient";
// import SummaryApi from "../common/SummaryApi";

// const OrdersPage = () => {
//   const [orders, setOrders] = useState([]);
//   const [filteredOrders, setFilteredOrders] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const [statusFilter, setStatusFilter] = useState("");
//   const [dateFilter, setDateFilter] = useState("");
//   const [search, setSearch] = useState("");

//   const fetchOrders = async () => {
//     setLoading(true);
//     const res = await api({
//       method: SummaryApi.getMyOrders.method,
//       url: SummaryApi.getMyOrders.url,
//     });

//     if (res.data.success) {
//       setOrders(res.data.orders);
//       setFilteredOrders(res.data.orders);
//     }
//     setLoading(false);
//   };

//   /* ✅ FILTER LOGIC */
//   useEffect(() => {
//     let data = [...orders];
//     const today = new Date();

//     // STATUS FILTER
//     if (statusFilter) {
//       data = data.filter(o => o.status === statusFilter);
//     }

//     // SEARCH FILTER
//     if (search) {
//       data = data.filter(o =>
//         o.items.some(item =>
//           item.productId.productName
//             .toLowerCase()
//             .includes(search.toLowerCase())
//         )
//       );
//     }

//     // DATE FILTER
//     if (dateFilter) {
//       data = data.filter(order => {
//         const orderDate = new Date(order.createdAt);

//         switch (dateFilter) {
//           case "TODAY":
//             return orderDate.toDateString() === today.toDateString();

//           case "YESTERDAY":
//             const y = new Date();
//             y.setDate(today.getDate() - 1);
//             return orderDate.toDateString() === y.toDateString();

//           case "CURRENT_MONTH":
//             return (
//               orderDate.getMonth() === today.getMonth() &&
//               orderDate.getFullYear() === today.getFullYear()
//             );

//           case "LAST_MONTH":
//             return (
//               orderDate.getMonth() === today.getMonth() - 1 &&
//               orderDate.getFullYear() === today.getFullYear()
//             );

//           case "LAST_YEAR":
//             return orderDate.getFullYear() === today.getFullYear() - 1;

//           default:
//             return true;
//         }
//       });
//     }

//     setFilteredOrders(data);
//   }, [statusFilter, search, dateFilter, orders]);

//   useEffect(() => {
//     fetchOrders();
//   }, []);

//   return (
//     <div>
//       {/* HEADER */}
//       <div className="mb-6">
//         <h1 className="text-2xl hidden lg:block font-semibold mb-2">
//           Order list
//         </h1>

//         <Breadcrumb
//           items={[
//             { label: "Home", path: "/" },
//             { label: "My Account", path: "/my-account/menu" },
//             { label: "My Orders" }
//           ]}
//         />
//       </div>

//       {/* FILTER BAR */}
//       <div className="flex flex-col md:flex-row gap-3 mb-6">
//         {/* DATE FILTER */}
//        <div className="flex flex-row gap-3">
//         <SelectDropdown
//           value={dateFilter}
//           onChange={setDateFilter}
//           placeholder="Select Date"
//           options={[
//             { id: "", label: "Select Date" },
//             { id: "TODAY", label: "Today" },
//             { id: "YESTERDAY", label: "Yesterday" },
//             { id: "CURRENT_MONTH", label: "Current month" },
//             { id: "LAST_MONTH", label: "Last month" },
//             { id: "LAST_YEAR", label: "Last year" }
//           ]}
//           parentClassName="md:w-[170px]"
//           ChildClassName="!bg-[#E7EFFF] border-none"
//           dropdownIcon={IoCaretDown}
//         />

//         {/* STATUS FILTER */}
//         <SelectDropdown
//           value={statusFilter}
//           onChange={setStatusFilter}
//           placeholder="Select Status"
//           options={[
//             { id: "", label: "All Status" },
//             { id: "ordered", label: "Ordered" },
//             { id: "packaged", label: "Packaged" },
//             { id: "shipped", label: "Shipped" },
//             { id: "delivered", label: "Delivered" },
//             { id: "pending", label: "Pending" },
//             { id: "cancelled", label: "Cancelled" },
//             { id: "returnRequested", label: "Return requested" },
//             { id: "returnAccepted", label: "Return accepted" },
//             { id: "returned", label: "Returned" }
//           ]}
//           parentClassName="md:w-[170px]"
//           ChildClassName="!bg-[#E7EFFF] border-none"
//           dropdownIcon={IoCaretDown}
//         />
//        </div>

//         {/* SEARCH */}
//         <div className="relative ml-auto w-full md:w-[350px]">
//           <Search
//             className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500"
//             size={16}
//           />
//           <input
//             value={search}
//             onChange={e => setSearch(e.target.value)}
//             placeholder="Search orders"
//             className="w-full pl-9 pr-4 py-2.5 text-sm rounded-xl bg-[#E7EFFF] border-none "
//           />
//         </div>
//       </div>

//       {/* ORDER LIST */}
//       <div className="space-y-4">
//         {loading ? (
//           <p className="text-center text-sm text-gray-500">
//             Loading orders...
//           </p>
//         ) : filteredOrders.length === 0 ? (
//           <p className="text-center text-sm text-gray-500">
//             No orders found
//           </p>
//         ) : (
//           filteredOrders.map(order => (
//             <OrderCard key={order._id} order={order} />
//           ))
//         )}
//       </div>
//     </div>
//   );
// };

// export default OrdersPage;


// import React, { useEffect, useState } from "react";
// import OrderCard from "../components/myAccountComponents/OrderCard";
// import Breadcrumb from "../components/BreadCrumb";
// import SelectDropdown from "../customStyles/SelectDropdown";
// import { Search } from "lucide-react";
// import { IoCaretDown } from "react-icons/io5";
// import api from "../common/apiClient";
// import SummaryApi from "../common/SummaryApi";

// const OrdersPage = () => {
//   const [orders, setOrders] = useState([]);
//   const [filteredOrders, setFilteredOrders] = useState([]);
//   const [loading, setLoading] = useState(true);
  
//   // 1. Add Error State
//   const [error, setError] = useState(null);

//   const [statusFilter, setStatusFilter] = useState("");
//   const [dateFilter, setDateFilter] = useState("");
//   const [search, setSearch] = useState("");

//   const fetchOrders = async () => {
//     setLoading(true);
//     setError(null); // Reset error before fetching

//     // 2. Wrap API call in try-catch
//     try {
//       const res = await api({
//         method: SummaryApi.getMyOrders.method,
//         url: SummaryApi.getMyOrders.url,
//       });

//       if (res.data.success) {
//         setOrders(res.data.orders);
//         setFilteredOrders(res.data.orders);
//       }
//     } catch (err) {
//       // 3. Handle the error safely
//       console.error("Error fetching orders:", err);
      
//       if (err.response && err.response.status === 401) {
//         // The interceptor handles the redirect, but we show a message briefly
//         setError("Session expired. Please login again.");
//       } else {
//         setError("Failed to load orders. Please check your connection.");
//       }
//     } finally {
//       // 4. Always stop loading, even if error occurs
//       setLoading(false);
//     }
//   };

//   /* ✅ FILTER LOGIC */
//   useEffect(() => {
//     let data = [...orders];
//     const today = new Date();

//     // STATUS FILTER
//     if (statusFilter) {
//       data = data.filter(o => o.status === statusFilter);
//     }

//     // SEARCH FILTER
//     if (search) {
//       data = data.filter(o =>
//         o.items.some(item =>
//           item.productId.productName
//             .toLowerCase()
//             .includes(search.toLowerCase())
//         )
//       );
//     }

//     // DATE FILTER
//     if (dateFilter) {
//       data = data.filter(order => {
//         const orderDate = new Date(order.createdAt);

//         switch (dateFilter) {
//           case "TODAY":
//             return orderDate.toDateString() === today.toDateString();

//           case "YESTERDAY":
//             const y = new Date();
//             y.setDate(today.getDate() - 1);
//             return orderDate.toDateString() === y.toDateString();

//           case "CURRENT_MONTH":
//             return (
//               orderDate.getMonth() === today.getMonth() &&
//               orderDate.getFullYear() === today.getFullYear()
//             );

//           case "LAST_MONTH":
//             return (
//               orderDate.getMonth() === today.getMonth() - 1 &&
//               orderDate.getFullYear() === today.getFullYear()
//             );

//           case "LAST_YEAR":
//             return orderDate.getFullYear() === today.getFullYear() - 1;

//           default:
//             return true;
//         }
//       });
//     }

//     setFilteredOrders(data);
//   }, [statusFilter, search, dateFilter, orders]);

//   useEffect(() => {
//     fetchOrders();
//   }, []);

//   return (
//     <div>
//       {/* HEADER */}
//       <div className="mb-6">
//         <h1 className="text-2xl hidden lg:block font-semibold mb-2">
//           Order list
//         </h1>

//         <Breadcrumb
//           items={[
//             { label: "Home", path: "/" },
//             { label: "My Account", path: "/my-account/menu" },
//             { label: "My Orders" }
//           ]}
//         />
//       </div>

//       {/* FILTER BAR */}
//       <div className="flex flex-col md:flex-row gap-3 mb-6">
//        <div className="flex flex-row gap-3">
//         <SelectDropdown
//           value={dateFilter}
//           onChange={setDateFilter}
//           placeholder="Select Date"
//           options={[
//             { id: "", label: "Select Date" },
//             { id: "TODAY", label: "Today" },
//             { id: "YESTERDAY", label: "Yesterday" },
//             { id: "CURRENT_MONTH", label: "Current month" },
//             { id: "LAST_MONTH", label: "Last month" },
//             { id: "LAST_YEAR", label: "Last year" }
//           ]}
//           parentClassName="md:w-[170px]"
//           ChildClassName="!bg-[#E7EFFF] border-none"
//           dropdownIcon={IoCaretDown}
//         />

//         <SelectDropdown
//           value={statusFilter}
//           onChange={setStatusFilter}
//           placeholder="Select Status"
//           options={[
//             { id: "", label: "All Status" },
//             { id: "ordered", label: "Ordered" },
//             { id: "packaged", label: "Packaged" },
//             { id: "shipped", label: "Shipped" },
//             { id: "delivered", label: "Delivered" },
//             { id: "pending", label: "Pending" },
//             { id: "cancelled", label: "Cancelled" },
//             { id: "returnRequested", label: "Return requested" },
//             { id: "returnAccepted", label: "Return accepted" },
//             { id: "returned", label: "Returned" }
//           ]}
//           parentClassName="md:w-[170px]"
//           ChildClassName="!bg-[#E7EFFF] border-none"
//           dropdownIcon={IoCaretDown}
//         />
//        </div>

//         <div className="relative ml-auto w-full md:w-[350px]">
//           <Search
//             className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500"
//             size={16}
//           />
//           <input
//             value={search}
//             onChange={e => setSearch(e.target.value)}
//             placeholder="Search orders"
//             className="w-full pl-9 pr-4 py-2.5 text-sm rounded-xl bg-[#E7EFFF] border-none "
//           />
//         </div>
//       </div>

//       {/* ORDER LIST / ERROR / LOADING */}
//       <div className="space-y-4">
//         {/* 5. Render Error Message if it exists */}
//         {error ? (
//           <div className="p-4 text-center bg-red-50 text-red-600 rounded-lg border border-red-200">
//             <p className="font-medium">{error}</p>
//           </div>
//         ) : loading ? (
//           <p className="text-center text-sm text-gray-500">
//             Loading orders...
//           </p>
//         ) : filteredOrders.length === 0 ? (
//           <p className="text-center text-sm text-gray-500">
//             No orders found
//           </p>
//         ) : (
//           filteredOrders.map(order => (
//             <OrderCard key={order._id} order={order} />
//           ))
//         )}
//       </div>
//     </div>
//   );
// };

// export default OrdersPage;

import React, { useEffect, useState } from "react";
import OrderCard from "../components/myAccountComponents/OrderCard";
import Breadcrumb from "../components/BreadCrumb";
import SelectDropdown from "../customStyles/SelectDropdown";
import { Search, PackageOpen, ShoppingBag } from "lucide-react"; // Added Icons
import { IoCaretDown } from "react-icons/io5";
import api from "../common/apiClient";
import SummaryApi from "../common/SummaryApi";
import { useNavigate } from "react-router-dom"; // Added for navigation

const OrdersPage = () => {
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [statusFilter, setStatusFilter] = useState("");
  const [dateFilter, setDateFilter] = useState("");
  const [search, setSearch] = useState("");
  
  const navigate = useNavigate(); // Hook for button navigation

  const fetchOrders = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await api({
        method: SummaryApi.getMyOrders.method,
        url: SummaryApi.getMyOrders.url,
      });

      if (res.data.success) {
        setOrders(res.data.orders);
        setFilteredOrders(res.data.orders);
      }
    } catch (err) {
      console.error("Error fetching orders:", err);
      if (err.response && err.response.status === 401) {
        setError("Session expired. Please login again.");
      } else {
        setError("Failed to load orders. Please check your connection.");
      }
    } finally {
      setLoading(false);
    }
  };

  /* ✅ FILTER LOGIC */
  useEffect(() => {
    let data = [...orders];
    const today = new Date();

    if (statusFilter) {
      data = data.filter(o => o.status === statusFilter);
    }

    if (search) {
      data = data.filter(o =>
        o.items.some(item =>
          item.productId.productName.toLowerCase().includes(search.toLowerCase())
        )
      );
    }

    if (dateFilter) {
      data = data.filter(order => {
        const orderDate = new Date(order.createdAt);
        switch (dateFilter) {
          case "TODAY": return orderDate.toDateString() === today.toDateString();
          case "YESTERDAY":
            const y = new Date();
            y.setDate(today.getDate() - 1);
            return orderDate.toDateString() === y.toDateString();
          case "CURRENT_MONTH":
            return orderDate.getMonth() === today.getMonth() && orderDate.getFullYear() === today.getFullYear();
          case "LAST_MONTH":
            return orderDate.getMonth() === today.getMonth() - 1 && orderDate.getFullYear() === today.getFullYear();
          case "LAST_YEAR": return orderDate.getFullYear() === today.getFullYear() - 1;
          default: return true;
        }
      });
    }

    setFilteredOrders(data);
  }, [statusFilter, search, dateFilter, orders]);

  useEffect(() => {
    fetchOrders();
  }, []);

  return (
    <div>
      {/* HEADER */}
      <div className="mb-6">
        <h1 className="text-2xl hidden lg:block font-semibold mb-2">Order list</h1>
        <Breadcrumb
          items={[
            { label: "Home", path: "/" },
            { label: "My Account", path: "/my-account/menu" },
            { label: "My Orders" }
          ]}
        />
      </div>

      {/* FILTER BAR */}
      <div className="flex flex-col md:flex-row gap-3 mb-6">
        <div className="flex flex-row gap-3">
          <SelectDropdown
            value={dateFilter}
            onChange={setDateFilter}
            placeholder="Select Date"
            options={[
              { id: "", label: "Select Date" },
              { id: "TODAY", label: "Today" },
              { id: "YESTERDAY", label: "Yesterday" },
              { id: "CURRENT_MONTH", label: "Current month" },
              { id: "LAST_MONTH", label: "Last month" },
              { id: "LAST_YEAR", label: "Last year" }
            ]}
            parentClassName="md:w-[170px]"
            ChildClassName="!bg-[#E7EFFF] border-none"
            dropdownIcon={IoCaretDown}
          />

          {/* <SelectDropdown
            value={statusFilter}
            onChange={setStatusFilter}
            placeholder="Select Status"
            options={[
              { id: "", label: "All Status" },
              { id: "ordered", label: "Ordered" },
              { id: "packaged", label: "Packaged" },
              { id: "shipped", label: "Shipped" },
              { id: "delivered", label: "Delivered" },
              { id: "pending", label: "Pending" },
              { id: "cancelled", label: "Cancelled" },
              { id: "returnRequested", label: "Return requested" },
              { id: "returnAccepted", label: "Return accepted" },
              { id: "returned", label: "Returned" }
            ]}
            parentClassName="md:w-[170px]"
            ChildClassName="!bg-[#E7EFFF] border-none"
            dropdownIcon={IoCaretDown}
          /> */}
        </div>

        <div className="relative ml-auto w-full md:w-[350px]">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" size={16} />
          <input
            value={search}
            onChange={e => setSearch(e.target.value)}
            placeholder="Search orders"
            className="w-full pl-9 pr-4 py-2.5 text-sm rounded-xl bg-[#E7EFFF] border-none focus:ring-2 focus:ring-blue-200 outline-none transition-all"
          />
        </div>
      </div>

      {/* ORDER LIST / ERROR / LOADING / EMPTY STATE */}
      <div className="space-y-4">
        {error ? (
          <div className="p-4 text-center bg-red-50 text-red-600 rounded-lg border border-red-200 animate-fade-in">
            <p className="font-medium">{error}</p>
          </div>
        ) : loading ? (
          /* MODERN LOADING SKELETON (Optional improvement) */
          <div className="flex flex-col items-center justify-center py-20 space-y-4">
             <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600"></div>
             <p className="text-gray-500 text-sm">Fetching your orders...</p>
          </div>
        ) : filteredOrders.length === 0 ? (
          
          /* ✨ MODERN EMPTY STATE DESIGN ✨ */
          <div className="flex flex-col items-center justify-center py-16 bg-white rounded-2xl border border-dashed border-gray-300">
            <div className="bg-blue-50 p-6 rounded-full mb-4 animate-bounce-slow">
              {search || statusFilter || dateFilter ? (
                 <Search size={48} className="text-blue-400" strokeWidth={1.5} />
              ) : (
                 <PackageOpen size={48} className="text-blue-500" strokeWidth={1.5} />
              )}
            </div>
            
            <h3 className="text-xl font-bold text-gray-800 mb-2">
              {search || statusFilter || dateFilter ? "No matching orders found" : "No orders yet"}
            </h3>
            
            <p className="text-gray-500 text-center max-w-sm mb-8 px-4">
              {search || statusFilter || dateFilter 
                ? "We couldn't find any orders matching your current filters. Try clearing them to see more." 
                : "Looks like you haven't placed any orders yet. Explore our products and start shopping!"}
            </p>

            {(search || statusFilter || dateFilter) ? (
              <button 
                onClick={() => {
                  setSearch("");
                  setStatusFilter("");
                  setDateFilter("");
                }}
                className="px-6 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-xl transition-colors duration-200"
              >
                Clear Filters
              </button>
            ) : (
              <button 
                onClick={() => navigate("/")} 
                className="flex items-center gap-2 px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-xl shadow-lg shadow-blue-200 transition-all duration-200 transform hover:-translate-y-1"
              >
                <ShoppingBag size={18} />
                Start Shopping
              </button>
            )}
          </div>

        ) : (
          filteredOrders.map(order => (
            <OrderCard key={order._id} order={order} />
          ))
        )}
      </div>
    </div>
  );
};

export default OrdersPage;